import { io, Socket } from 'socket.io-client'
import config from 'constants/config'
import { SocketEventHandlers } from '@luxuryescapes/contract-search'

export let globalSearchSocket: Socket<SocketEventHandlers> | undefined = undefined
export const SEARCH_STREAMING_PAGE_SIZE = 4

let searchSocketDisconnectTimeout: ReturnType<typeof setTimeout> | undefined = undefined

function forceDisconnectSearchSocket() {
  if (!globalSearchSocket) return
  globalSearchSocket.disconnect()
  globalSearchSocket = undefined
}

export function getSearchSocket() {
  // Cancel any pending disconnect since we're using the socket
  if (searchSocketDisconnectTimeout) {
    clearTimeout(searchSocketDisconnectTimeout)
    searchSocketDisconnectTimeout = undefined
  }

  // If socket is active, Socket.IO will handle connection/reconnection automatically
  if (globalSearchSocket?.active) {
    return globalSearchSocket
  }

  // No active socket - create a new one
  forceDisconnectSearchSocket()

  const protocol = config.SCHEME === 'http' ? 'ws' : 'wss'
  const uri = `${protocol}://${config.API_HOST}`

  globalSearchSocket = io(uri, {
    transports: ['websocket'],
    path: '/api/search/stream',
  })

  return globalSearchSocket
}

export function disconnectSearchSocket() {
  if (searchSocketDisconnectTimeout) {
    clearTimeout(searchSocketDisconnectTimeout)
  }
  // Delay disconnect by 5 seconds, only if no other activity occurs
  searchSocketDisconnectTimeout = setTimeout(() => {
    forceDisconnectSearchSocket()
    searchSocketDisconnectTimeout = undefined
  }, 5000)
}
